import request from "@/utils/request";


export function getAllStationOptions() {
    return request({
        url: "/api/services/app/Station/GetAllForDropDown",
        method: "GET"
    });
}


// WEBPACK FOOTER //
// ./src/api/station.js